import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";
import register from './modules/register'
import { getOidcClient } from '@/services/oidc-client';
import router from '@/router/index';
import digitalApi from '@/services/DigitalApiClient.js'

const getDefaultState = () => {
    return {
        otp: {
            verificationMethod: null,
            tokenRef: null,
            verificationMethods: null
        },
        accessToken: null,
        userPwd: null,
        user: {},
        isOidcEventsHandled: false,
        oat: null
    }
}

let isMyBeauty = window.location.pathname.includes("mybeauty") ? true : false;
let oidcClient = getOidcClient(isMyBeauty);

const state = getDefaultState();

const mutations = {
    setOAT(state, oat) {
        state.oat = oat;
    },

    saveTokenRef(state, tokenRefInfo) {
        state.otp.tokenRef = tokenRefInfo.tokenRef;
        state.otp.verificationMethod = tokenRefInfo.verificationMethod;
    },

    saveVerificationMethods(state, verificationMethods) {
        state.otp.verificationMethods = [...verificationMethods];
    },

    reset(state) {
        Object.assign(state, getDefaultState());
    },

    saveAccessToken(state, accessToken) {
        state.accessToken = accessToken;
    },

    savePwd(state, userPwd) {
        state.userPwd = userPwd;
    },
    TOKEN_REQUEST_PENDING: (state) => {
        state.user = { loading: true };
    },
    TOKEN_REQUEST_SUCCESS: (state) => {
        state.user = { loading: false }
    },
    TOKEN_REQUEST_FAILURE: (state, error) => {
        state.user = { error };
    },
    LOGOUT_REQUEST_PENDING: (state) => {
        state.user = { loading: true };
    },
    LOGOUT_REQUEST_SUCCESS: (state) => {
        state.user = {};
    },
    LOGOUT_REQUEST_FAILURE: (state, error) => {
        state.user = { error };
    },
    AUTHENTICATION_SUCCESS: (state, user) => {
        state.user = user;
    },
    OIDC_LIBRARY_EVENTS_HANDLED: (state) => {
        state.isOidcEventsHandled = true;
    },
}

const actions = {
    saveTokenRef({ commit }, tokenRefInfo) {
        commit('saveTokenRef', tokenRefInfo)
    },

    saveVerificationMethods({ commit }, verificationMethods) {
        commit('saveVerificationMethods', verificationMethods)
    },

    reset({ commit }) {
        commit('reset')
    },

    saveAccessToken({ commit }, accessToken) {
        commit('saveAccessToken', accessToken)
    },

    savePwd({ commit }, userPwd) {
        commit('savePwd', userPwd)
    },
    signin: () => {
        oidcClient.signinRedirect();
    },
    signinRedirectCallback: (context) => {
        return new Promise((resolve, reject) => {
            context.commit('TOKEN_REQUEST_PENDING');

            oidcClient.signinRedirectCallback()
                .then(response => {
                    context.commit('TOKEN_REQUEST_SUCCESS');
                    context.dispatch("setAuthenticationSuccess", response);
                    context.commit('saveAccessToken', response.access_token)
                    digitalApi.getUser().then((resultGetUser) => {
                        if (router?.currentRoute?.params?.isMyBeauty && !resultGetUser.isMyBeautyMember) {
                            router.push({ name: 'JoinMyBeauty', params: { user: resultGetUser } });
                        }
                        else if (resultGetUser.isRewards === false) {
                            router.push({ name: 'JoinRewardsHome', params: { user: resultGetUser, source: context.rootState?.source } });
                        } else if (!router?.currentRoute?.params?.isMyBeauty && resultGetUser.isMyBeautyMember) {
                            router.push({ path: '/en-gb/mybeauty/download', params: { isMyBeauty: true } });
                        }
                        else {
                            router.push({ name: 'DownloadAfterSignIn' });
                        }
                    })
                    resolve(response);
                }, error => {
                    context.commit('TOKEN_REQUEST_FAILURE', error);
                    reject(error);
                })
        })
    },
    setAuthenticationSuccess: (context, user) => {
        // Check if library is suscribed to OIDC library events
        if (!context.state.isOidcEventsHandled) {
            oidcClient.events.addAccessTokenExpired(() => {
                // TODO: Handling token expiration
            });
            context.commit('OIDC_LIBRARY_EVENTS_HANDLED');
        }
        console.log(user);
        context.commit("AUTHENTICATION_SUCCESS", user);
    },
    signOut: (context) => {
        context.commit('LOGOUT_REQUEST_PENDING')
        oidcClient.signoutRedirect()
            .then(() => {
                context.commit('LOGOUT_REQUEST_SUCCESS')
            })
            .catch(function (error) {
                context.commit('LOGOUT_REQUEST_FAILURE', error);
            })
    },
    checkAccess: (context, requiresAuth) => {
        return new Promise(resolve => {
            oidcClient = getOidcClient(router?.currentRoute?.params?.isMyBeauty);
            if (!requiresAuth) return resolve("OK")
            // Check if we have a token in Session Storage 
            const getUserPromise = new Promise(resolve => {
                oidcClient.getUser().then(user => {
                    resolve(user)
                }).catch(() => {
                    resolve(null)
                })
            })
            let statusCode = "UNAUTHORIZED";
            getUserPromise.then(user => {
                // Check if we have token information and if token is not expired
                if (user && !user.expired) {
                    statusCode = "OK";
                    context.dispatch("setAuthenticationSuccess", user);
                }
                resolve(statusCode)
            })
        })
    }
}

const getters = {
    accessToken(state) {
        return state.user.access_token;
    },
    isLoading(state) {
        return (state.user != null && state.user.isLoading);
    },
    tokenResponse(state) {
        return (state.user) ? state.user : {};
    },
    userProfile(state) {
        return (state.user
            && state.user.profile != null) ? state.user.profile : {};
    },
    userIsAuthenticated(state) {
        return (state.user
            && state.user.id_token != null);
    }
}

export default createStore({
    state,
    mutations,
    actions,
    getters,
    modules: {
        register
    },
    plugins: [createPersistedState()]
})
